<template>
  <v-app id="app">
    <v-content>
      <router-view />
      <v-snackbar v-model="alert" :timeout="0">
        New version is available
        <v-btn color="blue" text @click="refreshPage">
          Update
        </v-btn>
      </v-snackbar>
    </v-content>
  </v-app>
</template>

<script>
export default {
  name: 'app',
  data() {
    return {
      alert: false,
    }
  },
  created() {
    if (window && window.BroadcastChannel) {
      const channel = new BroadcastChannel('sw-messages')
      channel.addEventListener('message', event => {
        if (event.data && event.data.action === 'new_version') {
          this.alert = true
        }
      })
    }
  },
  methods: {
    refreshPage() {
      location.reload()
    },
  },
}
</script>

<style lang="scss">
@import '~@/styles/_mixins';
html {
  @include desktop {
    overflow-y: hidden !important;
  }
}
.tooltip {
  font-family: 'Roboto', sans-serif;
  font-size: 12px;
  text-align: center;
  .tooltip-inner {
    background: black;
    color: white;
    padding: 6px 13px;
    opacity: 0.8;
  }

  .tooltip-arrow {
    width: 0;
    height: 0;
    border-style: solid;
    position: absolute;
    margin: 5px;
    border-color: black;
    z-index: 1;
  }
  &[x-placement^='top'] {
    margin-bottom: 5px;

    .tooltip-arrow {
      border-width: 5px 5px 0 5px;
      border-left-color: transparent !important;
      border-right-color: transparent !important;
      border-bottom-color: transparent !important;
      bottom: -5px;
      left: calc(50% - 5px);
      margin-top: 0;
      margin-bottom: 0;
    }
  }
}
</style>
